// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"647":"c40b67cb","2149":"1b23e465","2839":"31d6cfe0","5164":"0437ad12","7011":"1b23e465","8840":"1b23e465"}[chunkId] + ".chunk.css";
};